import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const deleteLevelStructure = (resource, id, structureId) => {
  return axios.delete(`/api/${resource}/${id}/setup/level_structures/${structureId}`);
};

export const useDeleteLevelStructure = (resource, id, onSuccess) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (values) => deleteLevelStructure(resource, id, values),
    onSuccess: () => {
      enqueueSnackbar('Level structure successfully deleted', { variant: 'success' });
      onSuccess();
    },
    onError: (error) => {
      enqueueSnackbar(
        error?.response?.data?.description || error?.message || 'Some error occured',
        {
          variant: 'error',
        }
      );
    },
  });
};
